import { render } from "./purchase-policy-config.vue?vue&type=template&id=4e0a05d1"
import script from "./purchase-policy-config.vue?vue&type=script&lang=js"
export * from "./purchase-policy-config.vue?vue&type=script&lang=js"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__